var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    viewBox: "0 0 35 34",
    width: 35,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(0 1 -1 0 41 -7)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.22222 14.88914v-6.89632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.11854 7.99282h-6.89632"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.8049 9.37932c6.9395422 3.2888463 10.5853967 11.0253199 8.7044872 18.4708511s-8.7636636 12.5222403-16.4325935 12.1206563-13.98381036-6.1693881-15.0767937-13.7706474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.3184 7.99294c-.0000663.05519457-.0448387.09989832-.1000333.0998799s-.0999372-.04475205-.0999666-.09994665c-.0000295-.0551946.0446653-.09997594.0998599-.10005325.0265667-.00003721.0520563.01049852.0708437.02928216s.0293282.04427113.0292963.07083784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.20728 10.6596c-.0000663.0551972-.0448427.099902-.10004.0998799-.0551972-.0000221-.0999378-.0447627-.0999599-.0999599-.0000221-.0551973.0446827-.0999737.0998799-.10004.0265632-.0000319.0520477.0105062.0708308.0292892.018783.0187831.0293211.0442676.0292892.0708308"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.9 16.88184c-.00007731.0551946-.04485865.0998894-.10005325.0998599-.0551946-.0000294-.09992823-.044772-.09994665-.0999666s.04468533-.099967.0998799-.1000333c.02656671-.0000319.0520542.0105089.07083784.0292963s.02931937.044277.02928216.0708437"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 48v-48h48v48z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateArrow);
export default __webpack_public_path__ + "static/media/rotate-arrow.f4c77fb05a300ce7028a2689aecd2830.svg";
export { ForwardRef as ReactComponent };